export { default } from "./verified-badge-check";
